import React, { type FC, Suspense, useMemo } from 'react';
import { Provider } from 'react-redux';
import { createWidgetStore } from '@app/store/widget/widget-store';

const withWidgetProviders = <T,>(WrappedComponent: FC<T>): FC<T> => {
  return (props) => {
    const store = useMemo(() => createWidgetStore(), []);

    return (
      <Provider store={store}>
        <Suspense fallback={<div>Loading...</div>}>
          <WrappedComponent {...props} />
        </Suspense>
      </Provider>
    );
  };
};

export default withWidgetProviders;
